import styles from '../GeoBrowse.module.css';

export type StatCardItem = {
  label: string;
  value: string | number;
  sub?: string;
};

type StatCardsProps = {
  items: StatCardItem[];
};

export default function StatCards({ items }: StatCardsProps) {
  return (
    <div className={styles.statGrid}>
      {items.map(item => (
        <div key={item.label} className={styles.statCard}>
          <span className={styles.statLabel}>{item.label}</span>
          <span className={styles.statValue}>{item.value}</span>
          {item.sub && <span className={styles.statSub}>{item.sub}</span>}
        </div>
      ))}
    </div>
  );
}
